<template>
  <div class="size-selection">
    <div class="mb-3">
      {{ $t('chat.try_other_sizes') }}
    </div>
    <button
      v-for="item in buttons"
      :key="item.garment_size"
      class="mr-2 px-3"
      @click="$emit('select-size', item)"
    >
      {{ item.text }}
    </button>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },
  computed: {
    buttons() {
      return this.message.content.map(btn => ({
        ...btn.data,
        text: this.$t('chat.size', { msg: btn.data.garment_size }),
      }));
    },
  },
};
</script>
<style lang="scss" scoped>
.size-selection {
  padding: 0 16px 16px 16px;

  button {
    font-size: 16px;
    border-radius: 38px;
    border: 1px solid var(--primary-text);
    outline: none;
    transition: background-color 0.3s ease-out;

    &:active {
      background-color: var(--primary-text);
      color: var(--primary-button-text);
    }
  }
}
</style>
